<template>
  <div class="name-data-cell">
    <div class="name-data-cell__type">
      <custom-tooltip class="name-data-cell__type__tooltip" placement="left" popper-class="light-tooltip">
        <div slot='buttonContent'>
          <span class='material-icons-outlined'> person </span>
        </div>
        <div slot="content">
          <slot name="tooltip">
            <span class='tooltip-text' v-if="formattedType === userTypes.external">{{$t('user.management.external.user')}}</span>
            <span class='tooltip-text' v-else>{{$t('user.management.regular.user')}}</span>
          </slot>
        </div>
      </custom-tooltip>
    </div>
    <div class="name-data-cell__name">
      {{ getUserName }}
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import userType from '@/constants/users';
import CustomTooltip from '@/components/common/CustomTooltip.vue';

export default {
  name: 'NameTableCell',
  components: { CustomTooltip },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['companyData']),
    formattedType() {
      const domainOfEmail = this.item.email.split('@')[1];
      let type = userType.REGULAR;
      if (domainOfEmail.endsWith(this?.companyData?.domain)) {
        const prefix = domainOfEmail?.split(this?.companyData?.domain)?.[0];
        if (prefix.length > 0) {
          if (prefix.charAt(prefix.length - 1) === '.') {
            type = userType.REGULAR;
          } else {
            type = userType.EXTERNAL;
          }
        } else {
          type = userType.REGULAR;
        }
      } else {
        type = userType.EXTERNAL;
      }
      return type;
    },
    userTypes() {
      return {
        regular: userType.REGULAR,
        external: userType.EXTERNAL,
      };
    },
    getUserName() {
      let userName = `${this.item[this.column.field]}`;
      if (this.formattedType === this.userTypes.external) {
        userName += ` (${this.$t('user.management.external.user')})`;
      }
      return userName;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.name-data-cell {
  font-family: $font-family-medium;
  text-transform: capitalize;
  display: flex;
  justify-content: left;
  margin-left: rem(-43);
  &__name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__type {
    display: flex;
    align-items: center;
    margin-right: rem(20);
    margin-top: rem(2);
    &__tooltip {
      &:hover {
        cursor: default;
      }
    }
  }
}
</style>
